import ExtendedSidebarLayout from 'src/layouts/ExtendedSidebarLayout';
import AuthLayout from 'src/layouts/AuthLayout';

import dashboardsRoutes from './dashboards';
import managementRoutes from './management';
import authRoutes from './auth';
import baseRoutes from './base';

import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Home = Loader(lazy(() => import('src/content/overview')));

const router = [
  // Auth
  {
    path: 'auth',
    element: <AuthLayout />,
    children: authRoutes,
  },

  // Default
  {
    path: '',
    element: <ExtendedSidebarLayout />,
    children: [
      {
        path: '',
        element: <Home />,
      },

      {
        path: 'dashboards',
        children: dashboardsRoutes,
      },
      {
        path: 'management',
        children: managementRoutes,
      },
    ],
  },

  // Error/status
  {
    path: '',
    children: baseRoutes,
  },
];

export default router;
